import { Injectable, inject } from "@angular/core";
import { IFirmGroupsService } from "../shared";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";
import { MultiSelectModel, Option } from "./filter-types";

@Injectable({
    providedIn: "root",
})
export class IfirmGroupFilterGeneratorService {
    private readonly iFirmGroupsService = inject(IFirmGroupsService);

    constructor() {}

    async generateGroup1Model(selection: Option[]) {
        const iFirmGroups = await this.iFirmGroupsService.getiFirmGroups();
        const options: Option[] = iFirmGroups.group1Options
            .sort((a, b) => a.Id - b.Id)
            .map((option) => {
                return {
                    text: {
                        "en-CA": option["en-CA"],
                        "fr-CA": option["fr-CA"],
                    } as ITranslateObject,
                    value: option.Id.toString(),
                } as Option;
            });
        return {
            label: {
                "en-CA": iFirmGroups.group1["en-CA"],
                "fr-CA": iFirmGroups.group1["fr-CA"],
            } as ITranslateObject,
            applicableOptions: options,
            allOptions: options,
            selection: selection.filter((selected) => options.some((applicable) => selected.value === applicable.value)),
        } as MultiSelectModel;
    }

    async generateGroup2Model(selection: Option[]) {
        const iFirmGroups = await this.iFirmGroupsService.getiFirmGroups();
        const options: Option[] = iFirmGroups.group2Options
            .sort((a, b) => a.Id - b.Id)
            .map((option) => {
                return {
                    text: {
                        "en-CA": option["en-CA"],
                        "fr-CA": option["fr-CA"],
                    } as ITranslateObject,
                    value: option.Id.toString(),
                } as Option;
            });
        return {
            label: {
                "en-CA": iFirmGroups.group2["en-CA"],
                "fr-CA": iFirmGroups.group2["fr-CA"],
            } as ITranslateObject,
            applicableOptions: options,
            allOptions: options,
            selection: selection.filter((selected) => options.some((applicable) => selected.value === applicable.value)),
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    async generateGroup1Filter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: TaxprepT1Card) => {
                const group1 = card.group1Id;
                return selectedValues.includes(group1) || (group1 == null && selectedValues.includes("-1"));
            };
        }
    }

    async generateGroup2Filter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: TaxprepT1Card) => {
                const group2 = card.group2Id;
                return selectedValues.includes(group2) || (group2 == null && selectedValues.includes("-1"));
            };
        }
    }
}
